import { toLonLat } from "ol/proj";
import { LatLongControl } from "../controls/LatLongControl";

export function addLatLongControl(map, view, target) {
  const latLongControl = new LatLongControl(view, {
    target: target,
  });
  view.on("change:center", (event) => {
    const lonLatCenter = toLonLat(
      event.target.getCenter(),
      event.target.getProjection(),
    );
    latLongControl.set(
      "latLong",
      `${lonLatCenter[1].toFixed(7)}, ${lonLatCenter[0].toFixed(7)}`,
    );
  });
  map.addControl(latLongControl);
}
